import { UFOAbstractExperience } from './ufo-abstract-experience';

export class UFOExperience extends UFOAbstractExperience {}
